import React, { useRef, useState, useEffect } from "react";
import { Tooltip, Box } from "@mui/material";

const OverflowTooltip = ({ children }: { children: string }) => {
  const textRef = useRef<HTMLDivElement | null>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const element = textRef.current;
    if (element) {
      setIsOverflowing(element.scrollWidth > element.clientWidth);
    }
  }, [children]);

  return (
    <Tooltip title={isOverflowing ? children : ""} arrow placement="right">
      <Box
        ref={textRef}
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          width: "100%",
        }}
      >
        {children}
      </Box>
    </Tooltip>
  );
};

export default OverflowTooltip;
